export const isProd = process.env.VUE_APP_ENV === "prod";
export const isDev = process.env.VUE_APP_ENV === "dev";

export const API_SCOPE = isProd
  ? "api://cac7eb1b-c38f-4c79-8149-cce3091beb3d/ReadWrite"
  : isDev
  ? "api://4349a110-e08c-459c-8f1d-091232172c6c/ReadWrite"
  : "api://4349a110-e08c-459c-8f1d-091232172c6c/ReadWrite";

export const LOGIN_REQUEST_SCOPES = {
  scopes: ["User.Read"],
  extraScopesToConsent: [API_SCOPE]
};

export const AV_REQUEST_SCOPES = {
  scopes: [API_SCOPE]
};

export const SILENT_TOKEN_REFRESH_SCOPES = (currentAccount) => ({
  scopes: ["User.Read"],
  account: currentAccount,
  forceRefresh: false
});

export const AV_SILENT_TOKEN_REFRESH_SCOPES = (currentAccount) => ({
  scopes: [API_SCOPE],
  account: currentAccount,
  forceRefresh: false
});

export const Tenant = "05d75c05-fa1a-42e7-9cf1-eb416c396f2d";

export const CLIENT_ID = isProd
  ? "cac7eb1b-c38f-4c79-8149-cce3091beb3d"
  : isDev
  ? "4349a110-e08c-459c-8f1d-091232172c6c"
  : "4349a110-e08c-459c-8f1d-091232172c6c";

export const Redirect_Uri = isProd
  ? "https://cim.maersk-digital.net/"
  : isDev
  ? "https://cim.dev.maersk-digital.net/"
  : "http://localhost:8081";

export const Graph_Api_Base = "https://graph.windows.net";

export const Graph_Api_Resource = "00000002-0000-0000-c000-000000000000";

export const Msal_Config = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${Tenant}/`,
    requireAuthOnInitialize: true,
    autoRefreshToken: true,
    redirectUri: Redirect_Uri,
    postLogoutRedirectUri: Redirect_Uri
  },
  request: {
    scopes: ["User.Read"]
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true
  },
  graph: {
    callAfterInit: false
  }
};
